(() => {
  const sliders = document.querySelectorAll('[data-radiant-slider]');

  sliders.forEach((slider) => {
    const slides = Array.from(slider.querySelectorAll('.radiant-hero__slide'));
    const dots = slider.querySelector('.radiant-hero__dots');
    let activeIndex = 0;
    let intervalId;

    if (slides.length <= 1 || !dots) return;

    const buttons = slides.map((_, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', `Show slide ${index + 1}`);
      if (index === 0) button.classList.add('is-active');
      button.addEventListener('click', () => {
        setActive(index);
        restart();
      });
      dots.appendChild(button);
      return button;
    });

    function setActive(index) {
      slides[activeIndex].classList.remove('is-active');
      buttons[activeIndex].classList.remove('is-active');
      activeIndex = index;
      slides[activeIndex].classList.add('is-active');
      buttons[activeIndex].classList.add('is-active');
    }

    function next() {
      setActive((activeIndex + 1) % slides.length);
    }

    function restart() {
      window.clearInterval(intervalId);
      intervalId = window.setInterval(next, 5000);
    }

    slider.addEventListener('mouseenter', () => window.clearInterval(intervalId));
    slider.addEventListener('mouseleave', restart);
    restart();
  });

  document.querySelectorAll('[data-curtain-palette]').forEach((palette) => {
    const imageLink = palette.querySelector('[data-curtain-palette-link]');
    const image = imageLink ? imageLink.querySelector('img') : null;
    const title = palette.querySelector('[data-curtain-palette-title]');
    const swatches = Array.from(palette.querySelectorAll('[data-curtain-swatch]'));

    if (!image || !swatches.length) return;

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => {
        swatches.forEach((item) => {
          item.classList.remove('is-active');
          item.removeAttribute('aria-pressed');
        });

        swatch.classList.add('is-active');
        swatch.setAttribute('aria-pressed', 'true');

        if (swatch.dataset.image) {
          image.src = swatch.dataset.image;
        }

        if (swatch.dataset.title) {
          image.alt = swatch.dataset.title;
          if (title) title.textContent = swatch.dataset.title;
        }

        if (imageLink && swatch.dataset.link) {
          imageLink.href = swatch.dataset.link;
          window.location.href = swatch.dataset.link;
        }
      });
    });

    const activeSwatch = swatches.find((swatch) => swatch.classList.contains('is-active')) || swatches[0];
    activeSwatch.setAttribute('aria-pressed', 'true');
  });
})();
